import * as React from "react"
import posthog from "posthog-js"
import type { GatsbyBrowser } from "gatsby"
import "@fortawesome/fontawesome-free/css/all.min.css"
import "./src/styles/global.css"
import { AuthProvider } from "./src/context/auth-context"
import { LanguageProvider } from "./src/context/language-context"
import { PostHogErrorBoundary } from "./src/components/PostHogErrorBoundary"
import { captureInteraction } from "./src/utils/analytics"

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <AuthProvider>
    <PostHogErrorBoundary>{element}</PostHogErrorBoundary>
  </AuthProvider>
)

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => (
  <LanguageProvider
    initialLanguage={props.pageContext?.lang}
    pathname={props.location?.pathname}
    search={props.location?.search}
  >
    {element}
  </LanguageProvider>
)

export const onClientEntry = () => {
  const posthogKey = process.env.GATSBY_POSTHOG_KEY || "phc_AGuqGBfc85fuXm6iRcJ9QvcvXiWtky6quDHGNQLSBBUr"
  const posthogHost = process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com"

  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: "always",
      capture_exceptions: true,
    })
  }
}

export const onRouteUpdate = ({ prevLocation }: { prevLocation: Location | null }) => {
  const posthogKey = process.env.GATSBY_POSTHOG_KEY || "phc_AGuqGBfc85fuXm6iRcJ9QvcvXiWtky6quDHGNQLSBBUr"
  if (!posthogKey || prevLocation == null) {
    return
  }
  posthog.capture("$pageview")
  captureInteraction("route_changed", {
    from: prevLocation.pathname,
    to: window.location.pathname,
  })
}
